import React from "react";
import { Create, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { ThirdPartyAppForm } from "../Form/Form";
import { transformThirdPartyApp } from "../Form/transform";

export const ThirdPartyAppCreate = (props) => (
	<Create {...props} transform={transformThirdPartyApp}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
			<ThirdPartyAppForm isAddForm />
		</SimpleForm>
	</Create>
);
